import { translateText } from '@/services/utils/translationService';
import i18n from '@/i18n';

const processingElements = new Set();

export const translateForced = {
  async mounted(el) {
    await applyTranslation(el);
  },
  async updated(el) {
    await applyTranslation(el);
  }
};

async function applyTranslation(el) {
  const text = el.innerText.trim();
  if (!text || processingElements.has(el)) return;
  if (el.dataset.translated === text) return;

  const locale = i18n.global.locale.value || i18n.global.locale;
  
  try {
    processingElements.add(el);
    const translatedText = await translateText(text, locale);
    if (translatedText && translatedText !== text) {
      el.innerText = translatedText;
      el.dataset.translated = translatedText;
    }
  } catch (error) {
    console.error('Error in translate-forced directive:', error);
  } finally {
    processingElements.delete(el);
  }
}
